import { DownloadDialog } from '@root/entities/deeplinking/download-dialog/ui/download-dialog'
import { UnsafeUrlDialog } from '@root/entities/deeplinking/unsafe-url-dialog/ui/unsafe-url-dialog'
import { TransactionDetailsDialogController } from '@root/entities/transaction/ui/desktop'
import { BrowserLocalWarningDialog } from '@root/features/announcements/browser-local-warning-dialog/ui/browser-local-warning-dialog'
import { LogoutDialog } from '@root/features/auth/logout/ui/logout-dialog'
import { BackOfficeUsersWalletsModal } from '@root/features/back-office/user-wallets/back-office-users-wallets-modal'
import { BasicDepositDialog } from '@root/features/basic'
import { PairActivityNotifications } from '@root/features/pair-activity/ui'
import { CheckCurrencyDialog } from '@root/features/premium/check-currency/ui/desktop'
import { ProfileCoinsModal } from '@root/features/profile/profile-coins/ui/profile-coins-modal/profile-coins-modal'
import { InviteCodeDialogController } from '@root/features/referral/ui/desktop/invite-code-dialog/invite-code-dialog-controller'
import { ReferralDialogsController } from '@root/features/referral/ui/desktop/referral-dialogs-controller'
import { LocalPasswordDialogController } from '@root/features/secure-storage/ui'
import { WalletProfileModal } from '@root/features/services/wallet-profile/ui'
import { ReportDialogsController } from '@root/features/user/report/ui/desktop'
import { UserConnectionsFollowersModal } from '@root/features/user/user-connections/ui/user-connections-modal/user-connections-followers-modal'
import { UserConnectionsFollowingsModal } from '@root/features/user/user-connections/ui/user-connections-modal/user-connections-followings-modal'
import { TauriEnvironment } from '@root/shared/layout/tauri-environment/tauri-environment'
import { ConfirmDialogController } from '@root/shared/ui/confirm-dialog'
import { SettingsModal } from '@root/widgets/desktop/settings-modal'
import { PremiumCurrencyDialogController } from '@root/widgets/premium/premium-currency-details/ui/desktop/premium-currency-dialog-controller'
import { ReferralWithdrawDialogController } from '@root/widgets/referral/referral-withdraw/ui'

import { deeplinkBuyPremiumFlowModel } from '../common/use-deeplink-handlers'

import { OnboardingDialogs } from './onboarding-dialogs'

export const DesktopAppDialogs = () => {
  return (
    <>
      {/*
        Logging out is not the app's privilege.
        
        This dialog sat inside TauriEnvironment, which renders nothing on the
        web, so the sign-out button in the sidebar set its atom to true and
        absolutely nothing happened - the one control whose whole job is to
        work when you no longer want to be here. The mobile tree never had the
        wrapper and its drawer worked all along, which is why this only ever
        showed up on a desktop browser.
      */}
      <LogoutDialog />
      <TauriEnvironment>
        <ReportDialogsController />
        <ReferralDialogsController />
      </TauriEnvironment>
      <ReferralWithdrawDialogController />
      <CheckCurrencyDialog model={deeplinkBuyPremiumFlowModel} />
      <DownloadDialog />
      <UnsafeUrlDialog />
      <UserConnectionsFollowersModal />
      <UserConnectionsFollowingsModal />
      <ProfileCoinsModal />
      <PremiumCurrencyDialogController />
      <ConfirmDialogController />
      <SettingsModal />
      <PairActivityNotifications />
      {/* <ChangeReferralCodeModal /> */}
      <InviteCodeDialogController />
      <BackOfficeUsersWalletsModal />
      <LocalPasswordDialogController />
      <TransactionDetailsDialogController />
      <WalletProfileModal />
      <BrowserLocalWarningDialog />
      <BasicDepositDialog />
      <OnboardingDialogs />
    </>
  )
}
